import ModalWrapper from '../../ModalWrapper';
import ButtonComponent from '../../customButton';
import { RUN_LABEL } from '../constants';

function resultSummary(result, ok) {
  const text = result?.summary || result?.error || result?.test_status || '';
  if (text) return text;
  return ok ? 'The run finished successfully.' : 'The run did not finish successfully.';
}

/**
 * Single, unmissable signal for "did the run pass or fail" — a popup instead of a
 * small chip buried in the top bar, so a definitive success/failure can't be missed.
 */
export default function RunResultModal({ open, runLabel, result, onClose }) {
  if (!open) return null;
  const ok = runLabel === RUN_LABEL.COMPLETED;

  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      title={ok ? 'Run completed' : 'Run failed'}
      type={ok ? 'success' : 'error'}
      size="small"
      closeOnBackdrop
      footer={
        <ButtonComponent
          ctaText="Close"
          variant="primary"
          size="small"
          className="white bg-blue600"
          onClick={onClose}
        />
      }
    >
      <p>{resultSummary(result, ok)}</p>
    </ModalWrapper>
  );
}
